export enum DomainValidationErrorCode {
  INVALID_DOMAIN_FORMAT = 'INVALID_DOMAIN_FORMAT',
  NOT_BUSINESS_DOMAIN = 'NOT_BUSINESS_DOMAIN',
  DOMAIN_CREATION_FAILED = 'DOMAIN_CREATION_FAILED',
  DOMAIN_NOT_FOUND = 'DOMAIN_NOT_FOUND',
  OBSOLETE_DOMAIN = 'OBSOLETE_DOMAIN',
  EMAIL_NOT_ALLOWED = 'EMAIL_NOT_ALLOWED',
  ACCOUNT_CREATION_DISABLED = 'ACCOUNT_CREATION_DISABLED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
  }

export interface UserVerificationError {
  errorCode: DomainValidationErrorCode;
  errorMessage: string;
  extraInfo: string;
}

export const DomainValidationErrorDetails: Record<DomainValidationErrorCode, UserVerificationError> = {
  [DomainValidationErrorCode.INVALID_DOMAIN_FORMAT]: {
    errorCode: DomainValidationErrorCode.INVALID_DOMAIN_FORMAT,
    errorMessage: 'Invalid domain format',
    extraInfo: 'Please sign up with a valid email address to get started',
  },
  [DomainValidationErrorCode.NOT_BUSINESS_DOMAIN]: {
    errorCode: DomainValidationErrorCode.NOT_BUSINESS_DOMAIN,
    errorMessage: 'Domain is not a valid business domain',
    extraInfo: 'Please sign up with a valid business email to get started',
  },
  [DomainValidationErrorCode.DOMAIN_CREATION_FAILED]: {
    errorCode: DomainValidationErrorCode.DOMAIN_CREATION_FAILED,
    errorMessage: 'Signup is temporarily unavailable',
    extraInfo: 'Please try again later or contact our team at support@hud.io',
  },
  [DomainValidationErrorCode.DOMAIN_NOT_FOUND]: {
    errorCode: DomainValidationErrorCode.DOMAIN_NOT_FOUND,
    errorMessage: 'Signup is temporarily unavailable',
    extraInfo: 'Please try again later or contact our team at support@hud.io',
  },
  [DomainValidationErrorCode.OBSOLETE_DOMAIN]: {
    errorCode: DomainValidationErrorCode.OBSOLETE_DOMAIN,
    errorMessage: 'Seems like this account is not valid anymore',
    extraInfo: 'Please contact your account admin or our team at support@hud.io',
  },
  [DomainValidationErrorCode.EMAIL_NOT_ALLOWED]: {
    errorCode: DomainValidationErrorCode.EMAIL_NOT_ALLOWED,
    errorMessage: 'This email is not authorized for this domain',
    extraInfo: 'Please contact your account admin or our team at support@hud.io',
  },
  [DomainValidationErrorCode.UNKNOWN_ERROR]: {
    errorCode: DomainValidationErrorCode.UNKNOWN_ERROR,
    errorMessage: 'Signup is temporarily unavailable',
    extraInfo: 'Please try again later or contact our team at support@hud.io',
  },
  [DomainValidationErrorCode.ACCOUNT_CREATION_DISABLED]: {
    errorCode: DomainValidationErrorCode.ACCOUNT_CREATION_DISABLED,
    errorMessage: 'Hang tight - We are at capacity',
    extraInfo: 'We’re not accepting new accounts right now. You’ve been waitlisted and we’ll be in touch soon.',
  },
};
